(() => {
  if (window.RavenReferral) return;

  const ENDPOINT =
    'https://raven-creator-center.yuleptg.workers.dev/api/referral/source';

  const KEY = 'raven_ref_source_v1';

  const root =
    window.Shopify?.routes?.root || '/';

  let status = 'starting';
  let queue = Promise.resolve();

  function allowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;

      return (
        privacy?.analyticsProcessingAllowed?.() === true &&
        privacy?.marketingAllowed?.() === true
      );
    } catch {
      return false;
    }
  }

  function read() {
    try {
      return JSON.parse(
        localStorage.getItem(KEY) || 'null'
      );
    } catch {
      return null;
    }
  }

  function remove() {
    try {
      localStorage.removeItem(KEY);
    } catch {
      // Storage may be unavailable.
    }
  }

  function valid(source) {
    return (
      source &&
      /^[a-f0-9]{64}$/.test(source.token) &&
      Number.isFinite(source.expires_at) &&
      source.expires_at > Date.now()
    );
  }

  async function updateCart(token) {
    const response = await fetch(
      root + 'cart/update.js',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            raven_ref: token
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error('cart_update_failed');
    }

    const cart = await response.json();

    if (
      (cart.attributes?.raven_ref || '') !== token
    ) {
      throw new Error('cart_verification_failed');
    }
  }

  async function synchronize() {
    let source = read();

    if (!allowed()) {
      remove();

      if (source) {
        await updateCart('');
      }

      status = 'consent_unavailable';
      return;
    }

    if (source && !valid(source)) {
      remove();
      source = null;
    }

    const rawCode = new URL(
      location.href
    ).searchParams.get('ref');

    const code = rawCode
      ? rawCode.trim().toUpperCase()
      : '';

    const shouldIssue =
      /^[A-Z0-9_-]{3,40}$/.test(code) &&
      (
        !source ||
        source.code !== code ||
        Date.now() - source.issued_at >= 1800000
      );

    if (shouldIssue) {
      const response = await fetch(
        ENDPOINT,
        {
          method: 'POST',
          credentials: 'omit',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            code,
            path: location.pathname
          })
        }
      );

      if (response.ok) {
        const next = await response.json();

        if (!next.ok || !valid(next)) {
          throw new Error('invalid_source_response');
        }

        if (!allowed()) {
          remove();
          await updateCart('');

          status = 'consent_unavailable';
          return;
        }

        source = next;

        try {
          localStorage.setItem(
            KEY,
            JSON.stringify(source)
          );
        } catch {
          status = 'storage_unavailable';
          return;
        }
      } else if (
        response.status !== 404 &&
        response.status !== 400
      ) {
        throw new Error('source_request_failed');
      }
    }

    if (!allowed()) {
      remove();
      await updateCart('');

      status = 'consent_unavailable';
      return;
    }

    await updateCart(
      valid(source) ? source.token : ''
    );

    status = valid(source)
      ? 'cart_ready'
      : 'no_valid_source';
  }

  function run() {
    queue = queue
      .then(synchronize)
      .catch(error => {
        status = 'retry_required';

        console.warn(
          '[RavenReferral]',
          error.message
        );
      });

    return queue;
  }

  window.RavenReferral = {
    ready: () => queue,
    retry: run,
    status: () => status
  };

  document.addEventListener(
    'visitorConsentCollected',
    run
  );

  if (window.Shopify?.customerPrivacy) {
    run();
  } else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ],
      error => {
        if (error) {
          status = 'privacy_api_unavailable';
          return;
        }

        run();
      }
    );
  } else {
    status = 'privacy_api_unavailable';
  }
})();
